var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_4651)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_764_4651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.721 20H24.9457C23.8711 20 23 20.8711 23 21.9457V42.0544C23 43.1289 23.8711 44 24.9457 44H27.721C28.7956 44 29.6667 43.1289 29.6667 42.0544V21.9457C29.6667 20.8711 28.7956 20 27.721 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7132 20H36.9378C35.8633 20 34.9922 20.8711 34.9922 21.9457V42.0544C34.9922 43.1289 35.8633 44 36.9378 44H39.7132C40.7878 44 41.6589 43.1289 41.6589 42.0544V21.9457C41.6589 20.8711 40.7878 20 39.7132 20Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_764_4651",
    x: -0.347799,
    y: -3.3478,
    width: 65.3545,
    height: 70.6956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.94565
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.8913
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_764_4651"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.6739
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_764_4651",
    result: "effect2_dropShadow_764_4651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_764_4651",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_4651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.d806cec0f7f424e9ee366be92b932313.svg";
export { ForwardRef as ReactComponent };